module.exports = __webpack_public_path__ + "media/site_templates/www.wall-repair.com.au/images/splash-bf1bef1bd10585339d257a26bc3f1043.jpg";